<template>
  <div>
    <Dialog
      width="780px"
      :mobileRenderType="createRenderType == 'mobile' ? 'drawerDialog' : ''"
      :backgroundImage="false"
      :visible="popupVisible"
      @close="onCloseClick"
    >
      <div class="auth-select-box" aria-hidden="true">
        <div class="step text-[16px]">
          <div>1、为了您的账户安全，请完成个人实名认证或企业认证</div>
          <div>2、每个账号认证信息可修改一次</div>
        </div>
        <div class="info">
          <div class="item">
            <img src="@/assets/img/auth/person.png" alt="" />
            <div class="describe">
              <div class="flex-row-center">
                <div class="name font-bold text-[20px]">个人实名认证</div>
                <div
                  class="flag px-[8px] py-[2px] rounded-[4px] text-[12px] leading-[1.6] ml-[8px]"
                  :class="{
                    'bg-[rgba(255,160,43,0.2)] text-[#C56723]':
                      certificationState !== 2,
                    'bg-[rgba(28,255,130,0.1)] text-[#109312]':
                      certificationState === 2,
                  }"
                >
                  {{ certificationState === 2 ? "已认证" : "未认证" }}
                </div>
              </div>
              <div
                class="apply h-fit text-[14px] leading-[2] mt-[2px] text-[rgba(0,0,0,0.5)]"
              >
                适用于个人用户，账号归属个人
              </div>
            </div>
            <div class="flex1 flex justify-end items-center">
              <div
                v-if="personal_un_effect != 1 && certificationState != 2"
                class="pointer h-fit w-fit bg-[#000] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
                @click="handlePersonalAuth"
              >
                个人认证
              </div>
              <div
                v-else
                class="h-fit w-fit bg-[rgba(0,0,0,0.1)] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
              >
                个人认证
              </div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/auth/enterprise.png" alt="" />
            <div class="describe">
              <div class="flex-row-center">
                <div class="name font-bold text-[20px]">企业实名认证</div>
                <div
                  class="flag px-[8px] py-[2px] rounded-[4px] text-[12px] leading-[1.6] ml-[8px]"
                  :class="{
                    'bg-[rgba(255,160,43,0.2)] text-[#C56723]':
                      certificationState !== 1,
                    'bg-[rgba(28,255,130,0.1)] text-[#109312]':
                      certificationState === 1,
                  }"
                >
                  {{ certificationState === 1 ? "已认证" : "未认证" }}
                </div>
              </div>
              <div
                class="apply text-[14px] leading-[2] mt-[2px] text-[rgba(0,0,0,0.5)]"
              >
                适用于企业，学术机构等，账号归属企业
              </div>
            </div>
            <div class="flex1 flex justify-end items-center">
              <div
                v-if="enterprise_un_effect != 1 && certificationState != 1"
                class="pointer h-fit w-fit bg-[#000] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
                @click="handleEnterpriseAuth"
              >
                企业认证
              </div>
              <div
                v-else
                class="h-fit w-fit bg-[rgba(0,0,0,0.1)] text-[#fff] px-[32px] py-[6px] text-[14px] leading-[2] rounded-[40px]"
              >
                企业认证
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="personalVisible"
      width="648px"
      @close="onPersonalCloseClick"
    >
      <div>
        <div class="text-[18px]">个人认证</div>
        <div class="mt-[20px] bg-[rgba(0,0,0,0.05)] p-[20px] rounded-[8px]">
          <PersonalInfo @cancelSubmit="onPersonalCloseClick"></PersonalInfo>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="enterpriseVisible"
      width="648px"
      @close="onEnterpriseCloseClick"
    >
      <div>
        <div class="text-[18px]">企业认证</div>
        <div class="mt-[20px] bg-[rgba(0,0,0,0.05)] p-[20px] rounded-[8px]">
          <EnterpriseInfo
            @cancelSubmit="onEnterpriseCloseClick"
            @confirmSumbit="onEnterpriseCloseClick"
          ></EnterpriseInfo>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, watch, reactive } from "vue";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import PersonalInfo from "@/components/personalInfo/personalInfo.vue";
import EnterpriseInfo from "@/components/enterpriseInfo/enterpriseInfo.vue";

const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { certificationState, enterprise_un_effect, personal_un_effect, certificationDetail } =
  storeToRefs(userDataStore);

const props = defineProps({
  remove: {
    type: Function, //传入移除节点方法,这里是createApp中的方法
    default: null,
  },
});
const popupVisible = ref(true);
const personalVisible = ref(false);
const enterpriseVisible = ref(false);

const onCloseClick = () => {
  popupVisible.value = false;
  props.remove();
};

const handlePersonalAuth = () => {
  popupVisible.value = false;
  personalVisible.value = true;
};

const handleEnterpriseAuth = () => {
  popupVisible.value = false;
  enterpriseVisible.value = true;
};

const onPersonalCloseClick = () => {
  personalVisible.value = false;
  props.remove();
};

const onEnterpriseCloseClick = () => {
  enterpriseVisible.value = false;
  props.remove();
};

// const handleCancelPersonSubmit = () => {
//   personalVisible.value = false;
//   props.remove()
// }
</script>

<style lang="scss" scoped>
.auth-select-box {
  .step {
    padding-right: 46px;
    line-height: 28px;
  }
  .info {
    padding-top: 8px;
    .item {
      display: flex;
      background: rgba(0, 0, 0, 0.05);
      margin-top: 12px;
      padding: 30px 20px 30px 30px;
      border-radius: 12px;
      img {
        // width: ;
        height: 100px;
      }
      .describe {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 20px;
        // .flag {
        //     height: max-content;
        // }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .auth-select-box {
    .info {
      //   padding-top: 8px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: rgba(0, 0, 0, 0.05);
        margin-top: 12px;
        padding: 10px;
        img {
          width: 70%;
          height: auto;
        }
        .describe {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-left: 0px;
          margin-top: 4px;
        }
        .apply {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>